import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
    Layout,
    Menu,
    Dropdown,
    Icon,
    Popover,
    Checkbox,
    Tooltip,
    Button,
    Card,
    Divider,
    Input,
} from 'antd'
import SearchInput from '../../../../componentIsoMophic/ScrumBoard/SearchInput/SearchInput'
import { IconSvg } from '../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import modalActions from '../../../../redux/modal/actions'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import { variables } from '../../../assets/styles/variables'
import AvatarIcon from '../../../assets/images/icon/08-icon.svg'
import PlusIcon from '../../../assets/images/icon/24.svg'
import { Scrollbars } from 'react-custom-scrollbars'
import { StatusTask } from './constant'
import drawerActions from '../../../../redux/drawer/actions'
import moment from 'moment'
import defaultImgAvatar from '../../../../resource/image/defaultAvatar.png'

import { LstImage } from './LstImage'
import {
    ProjectInfoCard,
    Avatar,
    Category,
    Title,
    InfoWrapper,
    AssigneeWrapper,
    Assignee,
    DropdownHeader,
    ViewAll,
    Activity,
    Filters,
    Header,
    HeaderSecondary,
    ImageContainer,
} from './BoardLayout.style'

import defaultImg from '../../../../resource/image/imgTaskDefault.jpeg'
import { getTwoToneColor } from 'antd/lib/icon/twoTonePrimaryColor'

const { Content } = Layout

const BoardLayout = ({
    children,
    setSearchText,
    boards,
    currentBoard,
    currentListOrg,
    sentTaskToUser,
    listActivityTask,
    organizations,
    tasks,
    openDrawer,
    lastIdTask,
    getActivityTask,
    haveMoreData,
    resetLastIdActivity,
    updateStatusTask,
    userInfo,
    updateTask,
    getDetailTaskByIdDone,
}) => {
    useEffect(() => {
        return () => {
            console.log('clear bgr')
            setcurrentBgr('')
            setisSetcurrentBgr(false)
            getDetailTaskByIdDone({})
            setSearchText('')
        }
    }, [setcurrentBgr, setisSetcurrentBgr])
    const [isDown, setisDown] = useState(false)
    const [clientX, setclientX] = useState(0)
    const [scrollLeft, setscrollLeft] = useState(0)
    const [visibleMenu, setvisibleMenu] = useState(false)
    const [isShowChangeBgr, setisShowChangeBgr] = useState(false)
    const [currentBgr, setcurrentBgr] = useState()
    const [colorText, setcolorText] = useState('black')

    const [isSetcurrentBgr, setisSetcurrentBgr] = useState(false)

    const getImageLightness = imageSrc => {
        var img = document.createElement('img')
        img.src = imageSrc
        img.style.display = 'none'
        document.body.appendChild(img)

        var colorSum = 0

        img.onload = function() {
            // create canvas
            var canvas = document.createElement('canvas')
            canvas.width = this.width
            canvas.height = this.height

            var ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0)

            var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
            var data = imageData.data
            var r, g, b, avg

            for (var x = 0, len = data.length; x < len; x += 4) {
                r = data[x]
                g = data[x + 1]
                b = data[x + 2]

                avg = Math.floor((r + g + b) / 3)
                colorSum += avg
            }

            var brightness = Math.floor(colorSum / (this.width * this.height))
            console.log('brightness', brightness)
            if (brightness > 100) {
                setcolorText('black')
            } else {
                setcolorText('white')
            }
        }
    }
    const findImg = img => {
        const crrIMG = LstImage.find(name => {
            return name.name === img
        })

        if (crrIMG) {
            console.log('current img', crrIMG)

            return crrIMG.src
        } else {
            console.log('current img', LstImage[0].src)

            return LstImage[0].src
        }
    }
    if (currentBoard.background_url !== undefined && !isSetcurrentBgr) {
        console.log('set background img', currentBoard.background_url)
        setcurrentBgr(`url(${findImg(currentBoard.background_url)})`)
        setisSetcurrentBgr(true)
        getImageLightness(findImg(currentBoard.background_url))
    }

    const ListOrg = []
    if (currentListOrg) {
        currentListOrg.map(value => {
            ListOrg.push({ label: value.name, value: value.oid })
        })
    }
    const listTag = []
    if (currentBoard.lst_hashtag) {
        currentBoard.lst_hashtag.map(value => {
            listTag.push({ label: value, value: value })
        })
    }
    const getTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return (tm / 60) >> 0
        }
        if (tm < 86400) {
            return (tm / 3600) >> 0
        }
        if (tm > 86400) {
            return (tm / 86400) >> 0
        }
    }
    const getUnitTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return 'minutes'
        }
        if (tm < 86400) {
            return 'hours'
        }
        if (tm > 86400) {
            return 'days'
        }
    }
    const getNameOrgById = id => {
        const currentOrg = organizations.find(org => {
            return org.oid === id
        })
        if (currentOrg) {
            console.log('currentOrg', currentOrg)
            return currentOrg.name
        }
    }
    const findCurrentTaskById = activity => {
        if (activity.type_activity === 'type_task') {
            const currentTask = tasks.find(tasks => {
                return tasks.IdOfTask === activity.id_type
            })

            console.log('current task activity', currentTask)
            return currentTask
        }
        if (activity.type_activity === 'type_report') {
            const currentTask = tasks.find(tasks => {
                return tasks.id === activity.id_type
            })

            console.log('current task activity', currentTask)
            return currentTask
        }
        if (activity.type_activity === 'type_comment') {
            const currentTask = tasks.find(tasks => {
                if (activity.ext_data) {
                    return tasks.id == activity.ext_data.report_id
                }
            })
            console.log('current task activity', currentTask)
            return currentTask
        }
    }
    const menu = (
        <Menu>
            <Menu.Item>
                <DropdownHeader>Danh sách nhiệm vụ</DropdownHeader>
            </Menu.Item>

            {Object.values(boards).map(board => (
                <Menu.Item key={board.id}>
                    <Link to={`/app/qbtask/project/${board.id}`}>
                        <ProjectInfoCard>
                            <Avatar
                                src={
                                    board.avatar !== ''
                                        ? board.avatar
                                        : defaultImg
                                }
                            />
                            <InfoWrapper>
                                <Title>{board.title}</Title>
                                <Category>{board.category}</Category>
                            </InfoWrapper>
                        </ProjectInfoCard>
                    </Link>
                </Menu.Item>
            ))}

            <Menu.Item>
                <ViewAll>
                    <Link to="/app/qbtask">Danh sách nhiệm vụ</Link>
                </ViewAll>
            </Menu.Item>
        </Menu>
    )

    const scrollbar = useRef(null)

    const handleMouseMove = e => {
        if (isDown) {
            scrollbar.current.scrollLeft(scrollLeft - clientX + e.clientX)
        }
    }
    const updateImgBgr = src => {
        const dataUpdate = {
            avatar: currentBoard.avatar,
            deadline: currentBoard.deadline,
            lst_event_id: currentBoard.lst_event_id,
            lst_hashtag: currentBoard.lst_hashtag,
            lst_object_id: currentBoard.lst_object_id,
            lst_organ_receive_id: currentBoard.lst_organ_receive_id,
            lst_uid_receive: currentBoard.lst_uid_receive,
            lst_media: currentBoard.lst_media,
            name: currentBoard.title,
            note: currentBoard.content,
            process: currentBoard.process,
            background_url: src,
        }
        console.log('data update bgr', dataUpdate)
        updateTask(dataUpdate, currentBoard.id)
    }
    const sentTask = () => {
        sentTaskToUser(currentBoard.id)
    }
    const setActionTask = () => {
        updateStatusTask(currentBoard.id, 3)
    }
    const setFinishTask = () => {
        updateStatusTask(currentBoard.id, 4)
    }
    const ClickHref = activity => {
        openDrawer({
            drawerType: 'CARD_DETAILS',
            drawerProps: {
                task: findCurrentTaskById(activity),
                // columnId: 'column1',
            },
        })
        // if (type === 'type_task') {

        // } else {
        // }
    }
    const clickActivityBtn = () => {
        if (!visibleMenu) {
            resetLastIdActivity()
            getActivityTask(currentBoard.id, 1, 10)
        }
        setisShowChangeBgr(false)
        setvisibleMenu(!visibleMenu)
    }

    return (
        <Layout
            style={{
                // backgroundColor: `#0178c0`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundImage: currentBgr,
            }}
        >
            <Header>
                <Dropdown overlay={menu} overlayClassName="project-menu">
                    <div>
                        <ProjectInfoCard id="dropdown">
                            <Avatar src={defaultImg} />
                            <InfoWrapper>
                                <Title
                                    style={{
                                        color: colorText,
                                    }}
                                >
                                    {currentBoard.title}
                                </Title>
                            </InfoWrapper>
                            <Icon type="down" style={{ marginLeft: 16 }} />
                        </ProjectInfoCard>
                    </div>
                </Dropdown>

                <AssigneeWrapper>
                    <Tooltip
                        title="Gửi nhiệm vu đến các đơn vị tham gia"
                        placement="bottomRight"
                    >
                        {userInfo &&
                            (userInfo.tier_id === 100 ||
                                userInfo.uid === currentBoard.owner_id) &&
                            (currentBoard.status === StatusTask.TaskCreated && (
                                <div>
                                    <Button
                                        type="primary"
                                        onClick={() => sentTask()}
                                    >
                                        Gửi nhiệm vụ tới các đơn vị
                                    </Button>
                                </div>
                            ))}

                        {currentBoard.status === StatusTask.TaskSent && (
                            <div>
                                <Assignee style={{ color: colorText }}>
                                    Nhiệm vụ mới triển khai
                                </Assignee>
                                {userInfo &&
                                    (userInfo.tier_id === 100 ||
                                        userInfo.uid ===
                                            currentBoard.owner_id) &&
                                    (currentBoard.status ===
                                        StatusTask.TaskSent && (
                                        <div>
                                            <Button
                                                type="primary"
                                                onClick={() => setActionTask()}
                                            >
                                                Bắt đầu thực hiện nhiệm vụ
                                            </Button>
                                        </div>
                                    ))}
                            </div>
                        )}
                        {currentBoard.status === StatusTask.TaskAct && (
                            <div>
                                <Assignee style={{ color: colorText }}>
                                    Nhiệm vụ đang làm{' '}
                                </Assignee>
                                {userInfo &&
                                    (userInfo.tier_id === 100 ||
                                        userInfo.uid ===
                                            currentBoard.owner_id) &&
                                    (currentBoard.status ===
                                        StatusTask.TaskAct && (
                                        <div>
                                            <Button
                                                type="primary"
                                                onClick={() => setFinishTask()}
                                            >
                                                Hoàn thành nhiệm vụ
                                            </Button>
                                        </div>
                                    ))}
                            </div>
                        )}
                        {currentBoard.status === StatusTask.TaskFinish && (
                            <div>
                                <Assignee style={{ color: colorText }}>
                                    Nhiệm vụ đã hoàn thành{' '}
                                </Assignee>
                            </div>
                        )}
                        {currentBoard.status === StatusTask.TaskReceived && (
                            <div>
                                <Assignee style={{ color: colorText }}>
                                    Nhiệm vụ nhận về{' '}
                                </Assignee>
                            </div>
                        )}
                        {currentBoard.status === StatusTask.TaskDelete && (
                            <div>
                                <Assignee style={{ color: colorText }}>
                                    Nhiệm vụ này đã bị xoá{' '}
                                </Assignee>
                            </div>
                        )}
                    </Tooltip>
                </AssigneeWrapper>
            </Header>

            <HeaderSecondary>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        color: 'white',
                        alignItems: 'center',
                    }}
                ></div>
                <Filters>
                    <Button onClick={() => clickActivityBtn()}>
                        Hoạt động
                    </Button>
                </Filters>
            </HeaderSecondary>

            <Content
                style={{
                    width: '100%',
                    flexDirection: 'row',
                    display: 'flex',
                }}
            >
                <Scrollbars
                    style={{
                        width: visibleMenu ? 'calc(100vw - 400px)' : '100%',
                        height: 'calc(100vh - 200px)',
                        marginLeft: 10,
                    }}
                    ref={scrollbar}
                    renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{backgroundColor:'#c3c3c3', height: 5}}/>}
                    universal
                    onMouseOut={() => setisDown(false)}
                    onmouseover={() => console.log('mouse over')}
                    onMouseMove={handleMouseMove}
                    onMouseDown={e => {
                        setisDown(true)
                        setscrollLeft(scrollbar.current.getScrollLeft())
                        setclientX(e.clientX)
                    }}
                    onMouseUp={() => {
                        setisDown(false)
                        setclientX(0)
                        setscrollLeft(0)
                    }}
                    onMouseLeave={() => setisDown(false)}
                    autoHide
                >
                    {children}
                </Scrollbars>
                {visibleMenu && (
                    <div
                        style={{
                            backgroundColor: '#f4f5f7',
                            borderTopLeftRadius: 7,
                            borderTopRightRadius: 7,
                        }}
                    >
                        {!isShowChangeBgr && (
                            <Activity>
                                <div
                                    style={{
                                        height: 40,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        cursor: 'pointer',
                                        margin: 10,
                                        borderRadius: 7,
                                    }}
                                    onClick={() => setisShowChangeBgr(true)}
                                >
                                    {' '}
                                    <IconSvg
                                        src={require('../../../../resource/ImageBackGround/img1.jpg')}
                                        padding={'0'}
                                        radius={'20% 20% 20% 20%'}
                                        border={0}
                                    />
                                    Đổi hình nền
                                </div>
                            </Activity>
                        )}
                        {isShowChangeBgr && (
                            <Activity>
                                <div
                                    style={{
                                        height: 40,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        cursor: 'pointer',
                                        margin: 10,
                                        borderRadius: 7,
                                    }}
                                    onClick={() => setisShowChangeBgr(false)}
                                >
                                    {' '}
                                    <Icon
                                        type="menu"
                                        style={{
                                            paddingRight: 7,
                                            paddingLeft: 7,
                                        }}
                                    />
                                    Danh sách hoạt động
                                </div>
                            </Activity>
                        )}

                        {isShowChangeBgr && (
                            <Card
                                title={
                                    <p
                                        style={{
                                            alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <Icon type="border-verticle" />

                                        <text
                                            style={{
                                                fontSize: 18,
                                                paddingLeft: 10,
                                            }}
                                        >
                                            Đổi hình nền
                                        </text>
                                    </p>
                                }
                                extra={
                                    <Icon
                                        type="close"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setvisibleMenu(false)
                                            setisShowChangeBgr(false)
                                        }}
                                    />
                                }
                                style={{
                                    width: 400,
                                    height: 'calc(100vh - 200px)',
                                    backgroundColor: '#f4f5f7',
                                    borderRadius: 7,
                                }}
                            >
                                <ImageContainer>
                                    {LstImage.map(src => (
                                        <img
                                            style={{
                                                height: 120,
                                                width: 170,
                                                padding: 10,
                                                borderRadius: 15,
                                            }}
                                            onClick={() => {
                                                setcurrentBgr(`url(${src.src})`)
                                                updateImgBgr(src.name)
                                                getImageLightness(src.src)
                                            }}
                                            src={src.src}
                                        ></img>
                                    ))}
                                </ImageContainer>
                            </Card>
                        )}

                        {!isShowChangeBgr && (
                            <Card
                                title={
                                    <p
                                        style={{
                                            alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <Icon type="menu" />

                                        <text
                                            style={{
                                                fontSize: 18,
                                                paddingLeft: 10,
                                            }}
                                        >
                                            Danh sách hoạt động
                                        </text>
                                    </p>
                                }
                                extra={
                                    <Icon
                                        type="close"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setvisibleMenu(false)}
                                    />
                                }
                                style={{
                                    width: 400,
                                    height: 'calc(100vh - 200px)',
                                    backgroundColor: '#f4f5f7',
                                    borderRadius: 7,
                                }}
                            >
                                <Scrollbars
                                    style={{
                                        width: '100%',
                                        height: 'calc(100vh - 330px)',
                                        paddingLeft: 10,
                                    }}
                                >
                                    {listActivityTask.map(activity => (
                                        <div>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    marginRight: 20,
                                                }}
                                            >
                                                <Tooltip
                                                    title={getNameOrgById(
                                                        activity.id_organ
                                                    )}
                                                    placement="bottomRight"
                                                >
                                                    <Avatar
                                                        style={{
                                                            height: 30,
                                                            width: 30,
                                                            borderRadius: 15,
                                                        }}
                                                        src={
                                                            activity.avatar !==
                                                            ''
                                                                ? activity.avatar
                                                                : defaultImgAvatar
                                                        }
                                                    ></Avatar>
                                                </Tooltip>
                                                <p>
                                                    <text
                                                        style={{
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        {activity.user_action}{' '}
                                                    </text>
                                                    {activity.linking_words}{' '}
                                                    <text
                                                        style={{
                                                            textDecorationLine:
                                                                'underline',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            ClickHref(activity)
                                                        }
                                                    >
                                                        {activity.action_info}
                                                    </text>
                                                </p>
                                            </div>
                                            <p
                                                style={{
                                                    fontSize: 13,
                                                    marginLeft: 30,
                                                }}
                                            >
                                                {moment()
                                                    .subtract(
                                                        getTime(activity.time),
                                                        getUnitTime(
                                                            activity.time
                                                        )
                                                    )
                                                    .fromNow()}
                                            </p>
                                            <Divider />
                                        </div>
                                    ))}
                                    {haveMoreData && (
                                        <Button
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                            }}
                                            type="link"
                                            onClick={() =>
                                                getActivityTask(
                                                    currentBoard.id,
                                                    lastIdTask,
                                                    10
                                                )
                                            }
                                        >
                                            <text
                                                style={{
                                                    textDecorationLine:
                                                        'underline',
                                                }}
                                            >
                                                Xem thêm hoạt động
                                            </text>
                                        </Button>
                                    )}
                                </Scrollbars>
                            </Card>
                        )}
                    </div>
                )}
            </Content>
        </Layout>
    )
}

export default connect(
    (state, ownProps) => {
        return {
            currentListOrg: state.organization.currentListOrg,
            currentBoard: state.scrumBoard.currentBoard,
            listActivityTask: state.scrumBoard.listActivityTask,
            lastIdTask: state.scrumBoard.lastIdTask,
            organizations: state.organization.organizations,
            tasks: state.scrumBoard.tasks,
            haveMoreData: state.scrumBoard.haveMoreData,
            userInfo: state.auth.userInfo,
        }
    },
    { ...modalActions, ...scrumBoardActions, ...drawerActions }
)(BoardLayout)
